module.exports = {"130532001":"平乡县中华路街道","130532100":"丰州镇","130532101":"平乡镇","130532102":"河古庙镇","130532200":"节固乡","130532201":"油召乡","130532202":"田付村乡","130532203":"寻召乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130532.json
// module id = 131
// module chunks = 0